
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'


export interface ISubscriberState {
  isWarnningAlreadyOrganized: boolean,

}

const initialState: ISubscriberState = {
    isWarnningAlreadyOrganized: false,
}
export const subscriberSlice = createSlice({
  name: 'subscriber',
  initialState,
  reducers: {
    setWarningAlreadyOrganized: (state, action: PayloadAction<boolean>) => {
      state.isWarnningAlreadyOrganized = action.payload
    },
  },
})

export const { setWarningAlreadyOrganized } = subscriberSlice.actions
export default subscriberSlice.reducer
